import { ReactComponent as Icon1 } from "../svg/dor/ChatkaPuchatka_icon.svg";
import { ReactComponent as Icon2 } from "../svg/dor/wykonczenie_icon.svg";
import { ReactComponent as Icon3 } from "../svg/dor/nadzor_icon.svg";
import { ReactComponent as Icon4 } from "../svg/dor/systemy_icon.svg";
import { ReactComponent as Icon5 } from "../svg/dor/modernizacja_energetyczna.svg";

const icons = [Icon1, Icon2, Icon3, Icon4, Icon5];

export default icons;